module.exports = __webpack_public_path__ + "media/images/pokerroom/888/bonus-pict-59de0cb67801d3d4f9c5c6c1d759f382.jpg";